export const panelApp = `"""An autogenerated example Panel app."""

import panel as pn

pn.template.MaterialTemplate(
    site="Panel",
    title="Hello Numerous",
    main=[
      pn.pane.Markdown("# Hello world!"),
      pn.pane.Markdown("## I am a Panel app, deployed with Numerous")
    ],
  ).servable()
` as const;
